import { parseDateTime } from "shared/lib/date/parseDateTime";

/**
 * 서버 시간 문자열/Date를 한국시간(KST) 기준으로 다룬다.
 *
 * 백엔드가 서버 JVM 타임존을 KST(Asia/Seoul)로 맞춘 뒤로(서버 커밋 cec3af1,
 * TimeZone.setDefault), createdAt/lastLogin 등 서버 생성 시각이 KST 벽시계로
 * 내려온다. 따라서 더 이상 UTC→KST(+9h) 보정을 하지 않는다.
 *
 * ⚠️ 사용자가 직접 입력해 보내는 시각(게시기간 start/end, 일정 이벤트)은
 *    원래도 KST 벽시계 그대로라 보정 대상이 아니다.
 *
 * 참고: cec3af1 이전에 생성된 과거 레코드는 UTC 벽시계로 저장돼 있어 9시간
 * 이르게 보일 수 있다(백엔드 일괄 마이그레이션 여부 확인 필요). 신규 기준 정확.
 */
const ASSUME_SERVER_UTC = false;

const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

const pad = (n) => String(n).padStart(2, "0");

/**
 * 서버 생성 시각을 "비교/필터용 Date"로 변환한다.
 * 서버가 KST 벽시계로 내려주므로 그대로 Date로 파싱한다(ASSUME_SERVER_UTC=false).
 * isToday 등 new Date()(브라우저 현재시각, KST 가정)와의 비교에 사용한다.
 */
export const toKstDate = (value) => {
  const date = parseDateTime(value);
  if (!date) return null;
  return ASSUME_SERVER_UTC ? new Date(date.getTime() + KST_OFFSET_MS) : date;
};

/**
 * 서버 생성 시각을 KST 표시 문자열("YYYY. MM. DD. HH:mm:ss")로 변환한다.
 */
export const formatToKST = (value) => {
  if (!value) return "-";

  const date = toKstDate(value);
  if (!date) return String(value);

  return (
    `${date.getFullYear()}. ${pad(date.getMonth() + 1)}. ${pad(date.getDate())}. ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  );
};

export default formatToKST;
